import { Router } from '@angular/router';
import { HotjarService } from '../../auth-module/services/hotjarService';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import * as employmentActions from '../actions/employment';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { Observable, of } from 'rxjs';
import { EmploymentService } from '../services/employments';
import { Action, select, Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { FacebookService } from '../../lib/services';
import { Page } from '../../lib/classes/page';
import * as fromRoot from '../../reducers';
import { getSelectedUnit, getUserEmploymentsPagination } from '../../reducers';
import { Unit } from '../../settings-module/models/unit';

@Injectable()
export class EmploymentsEffects {
  @Effect()
  loadUserEmployments$: Observable<Action> = this.actions$.pipe(
    ofType<employmentActions.LoadUserEmployments>(
      employmentActions.ActionTypes.LoadUserEmployments
    ),
    withLatestFrom(this.store.pipe(select(getUserEmploymentsPagination))),
    map(([action, state]) => state),
    switchMap(pagination =>
      this.employmentService.getUserEmployments(pagination).pipe(
        map((userEmployments: Page<Array<any>>) => {
          const results = userEmployments.results;
          if (results.length) {
            this._handleEmployments(results);
            return new employmentActions.LoadUserEmploymentsSuccess({
              userEmployments: results,
              pagination: {
                next: userEmployments.next,
                previous: userEmployments.previous,
              },
            });
          } else {
            this._router.navigate(['login']);
            return new employmentActions.LoadUserEmploymentsFail({
              errors: 'no employments',
            });
          }
        }),
        catchError(errors => {
          this._router.navigate(['login']);
          console.error('fail?', errors);
          return of(new employmentActions.LoadEmploymentsFail({ errors }));
        })
      )
    )
  );

  @Effect()
  loadCurrentUnit$: Observable<Action> = this.actions$.pipe(
    ofType<employmentActions.LoadCurrentUnit>(
      employmentActions.ActionTypes.LoadCurrentUnit
    ),
    withLatestFrom(this.store.pipe(select(getSelectedUnit))),
    map(([action, state]) => action),
    switchMap(action =>
      this.employmentService.getUnit(action.payload.selectedUnitId).pipe(
        map((unit: Unit) => {
          return new employmentActions.LoadCurrentUnitSuccess({
            selectedUnit: unit,
          });
        }),
        catchError(errors => {
          return of(
            new employmentActions.LoadCurrentUnitFail({
              errors: errors,
            })
          );
        })
      )
    )
  );

  @Effect()
  loadCompanyEmployments$: Observable<Action> = this.actions$.pipe(
    ofType<employmentActions.LoadCompanyEmployments>(
      employmentActions.ActionTypes.LoadCompanyEmployments
    ),
    switchMap(action =>
      this.employmentService
        .getCompanyEmployments(action.payload.companyId)
        .pipe(
          map(
            companyEmployments =>
              new employmentActions.LoadCompanyEmploymentsSuccess({
                companyEmployments: companyEmployments.results,
              })
          ),
          catchError(errors =>
            of(
              new employmentActions.LoadEmploymentsFail({
                errors,
              })
            )
          )
        )
    )
  );

  _handleEmployments(employments) {
    this._hotjarService.vpv('/auth_component/auth_redirect_success');
    (<any>window).gtag('config', environment.googleAnalyticsTrackingId, {
      page_path: '/auth_redirect_success',
    });
    (<any>window).gtag('event', 'screen_view', {
      app_name: 'business.mojob.io',
      screen_name: '/auth_redirect_success',
    });
    this._facebookService.trackFacebookAnalyticsEvent(
      'comp_register_confirm_mail'
    );
    const unit_id = employments[0].id;
    const unit_id_from_storage = localStorage.getItem('unit_id');
    const unit_name = localStorage.getItem('unit_name');
    if (!unit_id_from_storage) {
      localStorage.setItem('unit_id', '' + unit_id);
    }
    if (!unit_name) {
      localStorage.setItem('unit_name', '' + employments[0].name);
    }

    return true;
  }

  constructor(
    private actions$: Actions,
    private employmentService: EmploymentService,
    private _hotjarService: HotjarService,
    private _facebookService: FacebookService,
    private _router: Router,
    private store: Store<fromRoot.State>
  ) {}
}
